// src/features/permissions/useRoles.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../../lib/api';

export interface RoleGrant {
  id: number;
  user_id: string;
  role: 'admin' | 'moderator';
  added_at: string;
}

export function useRoles(guildId: string | null) {
  return useQuery({
    queryKey: ['roles', guildId],
    queryFn: () => apiFetch<RoleGrant[]>(`/api/roles/${guildId}`),
    enabled: !!guildId,
  });
}

export function useGrantRole(guildId: string | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, role }: { userId: string; role: 'admin' | 'moderator' }) =>
      apiFetch(`/api/roles/${guildId}`, {
        method: 'POST',
        body: JSON.stringify({ userId, role }),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['roles', guildId] }),
  });
}

export function useRevokeRole(guildId: string | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) =>
      apiFetch(`/api/roles/${guildId}/${userId}`, { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['roles', guildId] }),
  });
}
